import AnamnesisView, { Views as ANAMNESIS_VIEWS } from 'components/organisms/Anamnesis';
import i18n from 'helper/i18n';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { actionCreators as eventsAC } from 'store/events';
import { actionCreators as profileAC, getIsUpdatingAnamnesis, getWeight } from 'store/profile';
import { IRootState } from 'store/rootReducer';
import { WithRouterType } from 'types/withRouter';
import { mapParentStateToProps } from '../Anamnesis';

const mapStateToProps = (state: IRootState, props: WithRouterType) => ({
	...mapParentStateToProps(state, props),
	currentStep: ANAMNESIS_VIEWS.DETERMINE_WEIGHT,
	isUpdatingAnamnesis: getIsUpdatingAnamnesis(state),
	introTitle: i18n('react.impulsCoach.components.anamnesis.determineWeight.introTitle'),
	introText: i18n('react.impulsCoach.components.anamnesis.determineWeight.introText'),
	title: i18n('react.impulsCoach.components.anamnesis.determineWeight.title'),
	inputField: {
		id: 'weight',
		name: 'weight',
		placeholderText: i18n('react.impulsCoach.components.anamnesis.determineWeight.placeholderText'),
		value: getWeight(state),
		step: 1,
		min: 21,
		max: 250,
		unit: 'kg',
	},
});

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			...profileAC,
			doAddEvents: eventsAC.doAddEvents,
		},
		dispatch
	);
};

export type DetermineWeightContainerProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AnamnesisView) as any);
